import React, { useEffect, useState } from "react";
import "antd/dist/antd.css";
import { Layout, Menu, Tooltip } from "antd";
import { useLocation } from "react-router-dom";

const SideBar = (props) => {
  const { collapsed, menuList } = props;

  const location = useLocation();

  const [openKeys, setOpenKeys] = useState([localStorage.getItem("keys")]);
  const [current, setCurrent] = useState(location.pathname === "/dashboard" ? "/" : location.pathname);

  const { Sider } = Layout;

  const onOpenChange = (keys) => {
    const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);
    if (menuList.indexOf(latestOpenKey) === -1) {
      setOpenKeys(keys);
    } else {
      setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
    }
    localStorage.setItem("keys", latestOpenKey);
  };

  useEffect(() => {
    if (location) {
      const pathSegments = location.pathname.split("/");

      let activeRoute = "";

      if (pathSegments.length > 2) {
        activeRoute = `/${pathSegments[1]}/${pathSegments[2]}`;

        if (location.pathname === activeRoute) {
          activeRoute = location.pathname;
        }
      } else {
        activeRoute = location.pathname;
      }

      if (current !== activeRoute) {
        setCurrent(activeRoute);
      }
    }
  }, [location, current]);

  const wrapMenuItemsWithTooltips = (items) => {
    return (
      items?.map((item) => {
        const newItem = { ...item };

        if (item.label) {
          let labelText = "";
          if (typeof item.label === "string") {
            labelText = item.label;
          } else if (React.isValidElement(item.label)) {
            labelText = item.label.props.children || "";
          } else {
            labelText = item.title || "";
          }

          newItem.label = (
            <Tooltip
              title={labelText}
              placement="right"
              mouseEnterDelay={0.3}
              getPopupContainer={() => document.body}
              overlayStyle={{
                position: "fixed",
                left: collapsed ? "80px" : "200px",
                transform: "translateX(10px)",
                zIndex: 9999,
              }}
              overlayInnerStyle={{
                backgroundColor: "#001529",
                color: "#fff",
                border: "1px solid #434343",
              }}
            >
              <div style={{ width: "100%", color: '#ffffffa6' }}>
                {item.label}
              </div>
            </Tooltip>
          );
        }

        if (item.children && item.children.length > 0) {
          newItem.children = wrapMenuItemsWithTooltips(item.children);
        }

        return newItem;
      }) || []
    );
  };

  const menuItemsWithTooltips = wrapMenuItemsWithTooltips(menuList);

  return (
    <Sider width={200} className="site-layout-background" collapsible collapsed={collapsed} trigger={null}>
       <style>
        {`
          .ant-menu-dark .ant-menu-submenu > .ant-menu .ant-menu-item a,
          .ant-menu-dark .ant-menu-item a {
            color: #ffffffa6 !important;
          }
        `}
      </style>
      <Menu
        mode="inline"
        selectedKeys={[current]}
        defaultOpenKeys={localStorage.getItem("keys")}
        openKeys={openKeys}
        onOpenChange={onOpenChange}
        style={{
          height: "100%",
          borderRight: 0,
        }}
        items={menuItemsWithTooltips}
        inlineCollapsed={collapsed}
        theme="dark"
      />
    </Sider>
  );
};
export default SideBar;